import SEOHead from '../components/SEOHead';

export default function TermsOfService() {
  return (
    <main data-testid="terms-page">
      <SEOHead
        title="Terms of Service | Trademark Legal Forum"
        description="Review Trademark Legal Forum's Terms of Service. Understand your rights and responsibilities when using our trademark registration and IP protection services."
      />
      <section className="relative pt-32 pb-20 md:pt-40 md:pb-28">
        <div className="absolute inset-0 bg-gradient-to-b from-[#0D1729] to-[#0A1128]" />
        <div className="container mx-auto px-6 md:px-12 relative z-10">
          <p className="uppercase text-xs tracking-[0.2em] font-bold text-[#D4AF37] mb-4 font-['Outfit']">Legal</p>
          <h1 className="text-4xl sm:text-5xl font-bold text-white font-['Outfit'] tracking-tight">Terms of Service</h1>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-[#0A1128]">
        <div className="container mx-auto px-6 md:px-12 max-w-4xl">
          <div className="prose prose-invert max-w-none space-y-8">
            <div>
              <h2 className="text-xl font-bold text-white font-['Outfit'] mb-4">1. Acceptance of Terms</h2>
              <p className="text-[#A0AABF] leading-relaxed">By accessing or using the services provided by Trademark Legal Forum, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services. These terms apply to all visitors, users, and others who access or use our services.</p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-white font-['Outfit'] mb-4">2. Description of Services</h2>
              <p className="text-[#A0AABF] leading-relaxed">Trademark Legal Forum provides trademark registration, intellectual property, business formation, and related legal services. Our services include, but are not limited to, trademark searches, application preparation, USPTO filing, office action responses, and trademark monitoring. We act as a service provider to assist with the filing process.</p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-white font-['Outfit'] mb-4">3. User Responsibilities</h2>
              <p className="text-[#A0AABF] leading-relaxed mb-3">When using our services, you agree to:</p>
              <ul className="list-disc pl-6 space-y-2 text-[#A0AABF]">
                <li>Provide accurate and complete information for your trademark applications</li>
                <li>Respond promptly to requests for additional information</li>
                <li>Not use our services for any unlawful purpose</li>
                <li>Not submit fraudulent or misleading information</li>
                <li>Comply with all applicable laws and regulations</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-bold text-white font-['Outfit'] mb-4">4. Fees and Payment</h2>
              <p className="text-[#A0AABF] leading-relaxed">Our service fees are as listed on our website at the time of purchase. Government filing fees are separate and not included in our service fees unless otherwise stated. All fees are non-refundable once work has commenced on your application, except as required by applicable law.</p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-white font-['Outfit'] mb-4">5. No Guarantee of Registration</h2>
              <p className="text-[#A0AABF] leading-relaxed">While we make every effort to prepare strong trademark applications, we cannot guarantee that the USPTO will approve any particular application. Trademark registration is subject to the approval of the examining attorney at the USPTO, and various factors outside our control may affect the outcome.</p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-white font-['Outfit'] mb-4">6. Intellectual Property</h2>
              <p className="text-[#A0AABF] leading-relaxed">All content on our website, including text, graphics, logos, and software, is the property of Trademark Legal Forum and is protected by intellectual property laws. You may not reproduce, distribute, or create derivative works from our content without our express written permission.</p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-white font-['Outfit'] mb-4">7. Limitation of Liability</h2>
              <p className="text-[#A0AABF] leading-relaxed">To the maximum extent permitted by law, Trademark Legal Forum shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from or related to your use of our services. Our total liability for any claim arising from these terms shall not exceed the amount you paid for the specific service giving rise to the claim.</p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-white font-['Outfit'] mb-4">8. Termination</h2>
              <p className="text-[#A0AABF] leading-relaxed">We reserve the right to terminate or suspend your access to our services at any time, without prior notice, for conduct that we believe violates these terms or is harmful to other users, us, or third parties, or for any other reason at our sole discretion.</p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-white font-['Outfit'] mb-4">9. Governing Law</h2>
              <p className="text-[#A0AABF] leading-relaxed">These terms shall be governed by and construed in accordance with the laws of the United States. Any disputes arising from these terms shall be resolved through binding arbitration in accordance with applicable rules.</p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-white font-['Outfit'] mb-4">10. Changes to Terms</h2>
              <p className="text-[#A0AABF] leading-relaxed">We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting to our website. Your continued use of our services after any changes constitutes acceptance of the new terms.</p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-white font-['Outfit'] mb-4">11. Contact Information</h2>
              <p className="text-[#A0AABF] leading-relaxed">For questions about these Terms of Service, please contact us through our Contact page or email us at info@trademarklegalforum.com.</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
